import { createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { PaymentTrackTypes } from './payment-track.actions'

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    fetchingRange: null,
    fetchingCollectedPayments: false,
    fetchingMissedPaymentsTrack: false,
    fetchingExternalPaymentsTrack: false,
    fetchingAccountsPaymentSearch: false,
    fetchingAccountsPaymentCsv: false,
    fetchingAccountsPaymentPdf: false,
    fetchingPaymentTracksCsv: null,
    fetchingPaymentTracksPdf: null,
    fetchingAccountsPaymentTotals: false,
    fetchingPaymentAttributions: null,
    fetchingFilteredDataTotals: null,
    fetchingPlanPaymentSummary: false,
    fetchingPlanReconciliationSummary: false,
    fetchingExternalColleagueSummary: false,
    fetchingExternalColleagueSummaryCsv: false,
    fetchingExternalColleagueSummaryPdf: false,
    fetchingPaymentTracksSummaryPdf: false,
    fetchingPaymentTracksReconciliationPdf: false,

    paymentTrackRange: null,
    collectedPaymentTracks: null,
    missedPaymentsTrack: null,
    externalPaymentsTrack: null,
    accountsPaymentSearch: null,
    accountsPaymentCsv: null,
    accountsPaymentPdf: null,
    paymentTracksCsv: null,
    paymentTracksPdf: null,
    accountsPaymentTotals: null,
    paymentAttributions: null,
    filteredDataTotals: null,
    planPaymentSummary: null,
    planReconciliationSummary: null,
    externalColleagueSummary: null,
    externalColleagueSummaryCsv: null,
    externalColleagueSummaryPdf: null,
    paymentTracksSummaryPdf: null,
    paymentTracksReconciliationPdf: null,

    errorRange: null,
    errorCollectedPayments: null,
    errorMissedPaymentsTrack: null,
    errorExternalPaymentsTrack: null,
    errorFetchingAccountsPaymentSearch: null,
    errorFetchingAccountsPaymentCsv: null,
    errorFetchingAccountsPaymentPdf: null,
    errorFetchingPaymentTracksCsv: null,
    errorFetchingPaymentTracksPdf: null,
    errorFetchingAccountsPaymentTotals: null,
    errorFetchingPaymentAttributions: null,
    errorFetchingFilteredDataTotals: null,
    errorPlanPaymentSummary: null,
    errorPlanReconciliationSummary: null,
    errorExternalColleagueSummary: null,
    errorExternalColleagueSummaryCsv: null,
    errorExternalColleagueSummaryPdf: null,
    errorFetchingPaymentTracksSummaryPdf: null,
    errorFetchingPaymentTracksReconciliationPdf: null,
})

/* ------------- Reducers ------------- */

// request the range of tracks from an api
export const rangeRequest = (state) => { return { ...state, fetchingRange: true, paymentTrackRange: null } }

export const collectedRequest = (state) => {
    return { ...state, fetchingCollectedPayments: true, collectedPaymentTracks: null, errorCollectedPayments: null };
};
export const missedTrackRequest = (state) => {
    return { ...state, fetchingMissedPaymentsTrack: true, missedPaymentsTrack: null, errorMissedPaymentsTrack: null };
};
export const externalTrackRequest = (state) => {
    return { ...state, fetchingExternalPaymentsTrack: true, externalPaymentsTrack: null, errorExternalPaymentsTrack: null };
};

export const accountsPaymentSearchRequest = (state) => {
    return { ...state, fetchingAccountsPaymentSearch: true, accountsPaymentSearch: null }
}
export const accountsPaymentCsvRequestReducer = (state) => {
    return { ...state, fetchingAccountsPaymentCsv: true, accountsPaymentCsv: null, errorFetchingAccountsPaymentCsv: null }
}
export const accountsPaymentPdfRequestReducer = (state) => {
    return { ...state, fetchingAccountsPaymentPdf: true, accountsPaymentPdf: null, errorFetchingAccountsPaymentPdf: null }
}
export const paymentTracksCsvRequest = (state) => {
    return { ...state, fetchingPaymentTracksCsv: true, paymentTracksCsv: null, errorFetchingPaymentTracksCsv: null }
}
export const paymentTracksPdfRequest = (state) => {
    return { ...state, fetchingPaymentTracksPdf: true, paymentTracksPdf: null, errorFetchingPaymentTracksPdf: null }
}
export const accountsPaymentTotalsRequestReducer = (state) => {
    return { ...state, fetchingAccountsPaymentTotals: true, accountsPaymentTotals: null }
}

export const paymentAttributionsRequest = (state) => {
    return { ...state, fetchingPaymentAttributions: true, paymentAttributions: null, errorFetchingPaymentAttributions: null }
}

export const filteredDataTotalsRequest = (state) => {
    return { ...state, fetchingFilteredDataTotals: true, filteredDataTotals: null, errorFetchingFilteredDataTotals: null }
}

export const planPaymentSummaryRequest = (state) => {
    return { ...state, fetchingPlanPaymentSummary: true, planPaymentSummary: null, errorPlanPaymentSummary: null }
}

export const planReconciliationSummaryRequest = (state) => {
    return { ...state, fetchingPlanReconciliationSummary: true, planReconciliationSummary: null, errorPlanReconciliationSummary: null }
}

export const externalColleagueSummaryRequest = (state) => {
    return { ...state, fetchingExternalColleagueSummary: true, externalColleagueSummary: null, errorExternalColleagueSummary: null }
}

export const externalColleagueSummaryCsvRequest = (state) => {
    return { ...state, fetchingExternalColleagueSummaryCsv: true, externalColleagueSummaryCsv: null, errorExternalColleagueSummaryCsv: null }
}

export const externalColleagueSummaryPdfRequest = (state) => {
    return { ...state, fetchingExternalColleagueSummaryPdf: true, externalColleagueSummaryPdf: null, errorExternalColleagueSummaryPdf: null }
}

export const paymentTracksSummaryPdfRequest = (state) => {
    return { ...state, fetchingPaymentTracksSummaryPdf: true, paymentTracksSummaryPdf: null, errorFetchingPaymentTracksSummaryPdf: null }
}

export const paymentTracksReconciliationPdfRequest = (state) => {
    return { ...state, fetchingPaymentTracksReconciliationPdf: true, paymentTracksReconciliationPdf: null, errorFetchingPaymentTracksReconciliationPdf: null }
}

// successful api lookup for range of schedules
export const rangeSuccess = (state, action) => {
    const { paymentTrackRange } = action
    return {
        ...state,
        fetchingRange: false,
        errorRange: null,
        paymentTrackRange
    }
}

export const collectedSuccess = (state, action) => {
    const { paymentTrack } = action;
    return { ...state, fetchingCollectedPayments: false, errorCollectedPayments: null, collectedPaymentTracks: paymentTrack };
};
export const missedTrackSuccess = (state, action) => {
    const { paymentTrack } = action;
    return { ...state, fetchingMissedPaymentsTrack: false, errorMissedPaymentsTrack: null, missedPaymentsTrack: paymentTrack };
};
export const externalTrackSuccess = (state, action) => {
    const { paymentTrack } = action;
    return { ...state, fetchingExternalPaymentsTrack: false, errorExternalPaymentsTrack: null, externalPaymentsTrack: paymentTrack };
};

export const accountsPaymentSearchSuccessReducer = (state, action) => {
    const { accountsPaymentSearch } = action
    return { ...state, fetchingAccountsPaymentSearch: false, accountsPaymentSearch }
}
export const accountsPaymentCsvSuccessReducer = (state, action) => {
    const { accountsPaymentCsv } = action
    return { ...state, fetchingAccountsPaymentCsv: false, accountsPaymentCsv, errorFetchingAccountsPaymentCsv: null }
}
export const accountsPaymentPdfSuccessReducer = (state, action) => {
    const { accountsPaymentPdf } = action
    return { ...state, fetchingAccountsPaymentPdf: false, accountsPaymentPdf, errorFetchingAccountsPaymentPdf: null }
}
export const paymentTracksCsvSuccess = (state, action) => {
    const { csv } = action
    return { ...state, fetchingPaymentTracksCsv: false, paymentTracksCsv: csv, errorFetchingPaymentTracksCsv: null }
}
export const paymentTracksPdfSuccess = (state, action) => {
    const { pdf } = action
    return { ...state, fetchingPaymentTracksPdf: false, paymentTracksPdf: pdf, errorFetchingPaymentTracksPdf: null }
}
export const accountsPaymentTotalsSuccessReducer = (state, action) => {
    const { accountsPaymentTotals } = action
    return { ...state, fetchingAccountsPaymentTotals: false, accountsPaymentTotals }
}
export const paymentAttributionsSuccess = (state, action) => {
    const { paymentAttributions } = action
    return { ...state, fetchingPaymentAttributions: false, paymentAttributions, errorFetchingPaymentAttributions: null }
}

export const filteredDataTotalsSuccess = (state, action) => {
    const { data } = action
    return { ...state, fetchingFilteredDataTotals: false, filteredDataTotals: data, errorFetchingFilteredDataTotals: null }
}

export const planPaymentSummarySuccess = (state, action) => {
    const { planPaymentSummary } = action
    return { ...state, fetchingPlanPaymentSummary: false, planPaymentSummary, errorPlanPaymentSummary: null }
}

export const planReconciliationSummarySuccess = (state, action) => {
    const { planReconciliationSummary } = action
    return { ...state, fetchingPlanReconciliationSummary: false, planReconciliationSummary, errorPlanReconciliationSummary: null }
}

export const externalColleagueSummarySuccess = (state, action) => {
    const { externalColleagueSummary } = action
    return { ...state, fetchingExternalColleagueSummary: false, externalColleagueSummary, errorExternalColleagueSummary: null }
}

export const externalColleagueSummaryCsvSuccess = (state, action) => {
    const { csv } = action
    return { ...state, fetchingExternalColleagueSummaryCsv: false, externalColleagueSummaryCsv: csv, errorExternalColleagueSummaryCsv: null }
}

export const externalColleagueSummaryPdfSuccess = (state, action) => {
    const { pdf } = action
    return { ...state, fetchingExternalColleagueSummaryPdf: false, externalColleagueSummaryPdf: pdf, errorExternalColleagueSummaryPdf: null }
}

export const paymentTracksSummaryPdfSuccess = (state, action) => {
    const { pdf } = action
    return { ...state, fetchingPaymentTracksSummaryPdf: false, paymentTracksSummaryPdf: pdf, errorFetchingPaymentTracksSummaryPdf: null }
}

export const paymentTracksReconciliationPdfSuccess = (state, action) => {
    const { pdf } = action
    return { ...state, fetchingPaymentTracksReconciliationPdf: false, paymentTracksReconciliationPdf: pdf, errorFetchingPaymentTracksReconciliationPdf: null }
}

// Something went wrong fetching range of tracks
export const rangeFailure = (state, action) => {
    const { error } = action
    return {
        ...state,
        fetchingRange: false,
        errorRange: error,
        paymentTrackRange: null
    }
}

export const collectedFailure = (state, action) => {
    const { error } = action;
    return { ...state, fetchingCollectedPayments: false, errorCollectedPayments: error, collectedPaymentTracks: null };
};

export const missedTrackFailure = (state, action) => {
    const { error } = action;
    return { ...state, fetchingMissedPaymentsTrack: false, errorMissedPaymentsTrack: error, missedPaymentsTrack: null };
};

export const externalTrackFailure = (state, action) => {
    const { error } = action;
    return { ...state, fetchingExternalPaymentsTrack: false, errorExternalPaymentsTrack: error, externalPaymentsTrack: null };
};

export const accountsPaymentSearchFailureReducer = (state, action) => {
    const { error } = action
    return { ...state, fetchingAccountsPaymentSearch: false, accountsPaymentSearch: null, errorFetchingAccountsPaymentSearch: error }
}
export const accountsPaymentCsvFailureReducer = (state, action) => {
    const { error } = action
    return { ...state, fetchingAccountsPaymentCsv: false, accountsPaymentCsv: null, errorFetchingAccountsPaymentCsv: error }
}
export const accountsPaymentPdfFailureReducer = (state, action) => {
    const { error } = action
    return { ...state, fetchingAccountsPaymentPdf: false, accountsPaymentPdf: null, errorFetchingAccountsPaymentPdf: error }
}
export const paymentTracksCsvFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingPaymentTracksCsv: false, paymentTracksCsv: null, errorFetchingPaymentTracksCsv: error }
}
export const paymentTracksPdfFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingPaymentTracksPdf: false, paymentTracksPdf: null, errorFetchingPaymentTracksPdf: error }
}
export const accountsPaymentTotalsFailureReducer = (state, action) => {
    const { error } = action
    return { ...state, fetchingAccountsPaymentTotals: false, accountsPaymentTotals: null, errorFetchingAccountsPaymentTotals: error }
}
export const paymentAttributionsFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingPaymentAttributions: false, paymentAttributions: null, errorFetchingPaymentAttributions: error }
}
export const filteredDataTotalsFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingFilteredDataTotals: false, filteredDataTotals: null, errorFetchingFilteredDataTotals: error }
}

export const planPaymentSummaryFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingPlanPaymentSummary: false, planPaymentSummary: null, errorPlanPaymentSummary: error }
}

export const planReconciliationSummaryFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingPlanReconciliationSummary: false, planReconciliationSummary: null, errorPlanReconciliationSummary: error }
}

export const externalColleagueSummaryFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingExternalColleagueSummary: false, externalColleagueSummary: null, errorExternalColleagueSummary: error }
}

export const externalColleagueSummaryCsvFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingExternalColleagueSummaryCsv: false, externalColleagueSummaryCsv: null, errorExternalColleagueSummaryCsv: error }
}

export const externalColleagueSummaryPdfFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingExternalColleagueSummaryPdf: false, externalColleagueSummaryPdf: null, errorExternalColleagueSummaryPdf: error }
}

export const paymentTracksSummaryPdfFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingPaymentTracksSummaryPdf: false, paymentTracksSummaryPdf: null, errorFetchingPaymentTracksSummaryPdf: error }
}

export const paymentTracksReconciliationPdfFailure = (state, action) => {
    const { error } = action
    return { ...state, fetchingPaymentTracksReconciliationPdf: false, paymentTracksReconciliationPdf: null, errorFetchingPaymentTracksReconciliationPdf: error }
}


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [PaymentTrackTypes.PAYMENT_TRACK_RANGE_REQUEST]: rangeRequest,
    [PaymentTrackTypes.COLLECTED_PAYMENT_TRACK_REQUEST]: collectedRequest,
    [PaymentTrackTypes.MISSED_PAYMENT_TRACK_REQUEST]: missedTrackRequest,
    [PaymentTrackTypes.EXTERNAL_PAYMENT_TRACK_REQUEST]: externalTrackRequest,
    [PaymentTrackTypes.PAYMENT_ATTRIBUTIONS_REQUEST]: paymentAttributionsRequest,
    [PaymentTrackTypes.FILTERED_DATA_TOTALS_REQUEST]: filteredDataTotalsRequest,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_SEARCH_REQUEST]: accountsPaymentSearchRequest,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_CSV_REQUEST]: accountsPaymentCsvRequestReducer,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_PDF_REQUEST]: accountsPaymentPdfRequestReducer,
    [PaymentTrackTypes.PAYMENT_TRACKS_CSV_REQUEST]: paymentTracksCsvRequest,
    [PaymentTrackTypes.PAYMENT_TRACKS_PDF_REQUEST]: paymentTracksPdfRequest,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_TOTALS_REQUEST]: accountsPaymentTotalsRequestReducer,
    [PaymentTrackTypes.PLAN_PAYMENT_SUMMARY_REQUEST]: planPaymentSummaryRequest,
    [PaymentTrackTypes.PLAN_RECONCILIATION_SUMMARY_REQUEST]: planReconciliationSummaryRequest,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_REQUEST]: externalColleagueSummaryRequest,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_CSV_REQUEST]: externalColleagueSummaryCsvRequest,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_PDF_REQUEST]: externalColleagueSummaryPdfRequest,
    [PaymentTrackTypes.PAYMENT_TRACKS_SUMMARY_PDF_REQUEST]: paymentTracksSummaryPdfRequest,
    [PaymentTrackTypes.PAYMENT_TRACKS_RECONCILIATION_PDF_REQUEST]: paymentTracksReconciliationPdfRequest,

    [PaymentTrackTypes.PAYMENT_TRACK_RANGE_SUCCESS]: rangeSuccess,
    [PaymentTrackTypes.COLLECTED_PAYMENT_TRACK_SUCCESS]: collectedSuccess,
    [PaymentTrackTypes.MISSED_PAYMENT_TRACK_SUCCESS]: missedTrackSuccess,
    [PaymentTrackTypes.EXTERNAL_PAYMENT_TRACK_SUCCESS]: externalTrackSuccess,
    [PaymentTrackTypes.PAYMENT_ATTRIBUTIONS_SUCCESS]: paymentAttributionsSuccess,
    [PaymentTrackTypes.FILTERED_DATA_TOTALS_SUCCESS]: filteredDataTotalsSuccess,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_SEARCH_SUCCESS]: accountsPaymentSearchSuccessReducer,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_CSV_SUCCESS]: accountsPaymentCsvSuccessReducer,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_PDF_SUCCESS]: accountsPaymentPdfSuccessReducer,
    [PaymentTrackTypes.PAYMENT_TRACKS_CSV_SUCCESS]: paymentTracksCsvSuccess,
    [PaymentTrackTypes.PAYMENT_TRACKS_PDF_SUCCESS]: paymentTracksPdfSuccess,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_TOTALS_SUCCESS]: accountsPaymentTotalsSuccessReducer,
    [PaymentTrackTypes.PLAN_PAYMENT_SUMMARY_SUCCESS]: planPaymentSummarySuccess,
    [PaymentTrackTypes.PLAN_RECONCILIATION_SUMMARY_SUCCESS]: planReconciliationSummarySuccess,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_SUCCESS]: externalColleagueSummarySuccess,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_CSV_SUCCESS]: externalColleagueSummaryCsvSuccess,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_PDF_SUCCESS]: externalColleagueSummaryPdfSuccess,
    [PaymentTrackTypes.PAYMENT_TRACKS_SUMMARY_PDF_SUCCESS]: paymentTracksSummaryPdfSuccess,
    [PaymentTrackTypes.PAYMENT_TRACKS_RECONCILIATION_PDF_SUCCESS]: paymentTracksReconciliationPdfSuccess,

    [PaymentTrackTypes.PAYMENT_TRACK_RANGE_FAILURE]: rangeFailure,
    [PaymentTrackTypes.COLLECTED_PAYMENT_TRACK_FAILURE]: collectedFailure,
    [PaymentTrackTypes.MISSED_PAYMENT_TRACK_FAILURE]: missedTrackFailure,
    [PaymentTrackTypes.EXTERNAL_PAYMENT_TRACK_FAILURE]: externalTrackFailure,
    [PaymentTrackTypes.PAYMENT_ATTRIBUTIONS_FAILURE]: paymentAttributionsFailure,
    [PaymentTrackTypes.FILTERED_DATA_TOTALS_FAILURE]: filteredDataTotalsFailure,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_SEARCH_FAILURE]: accountsPaymentSearchFailureReducer,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_CSV_FAILURE]: accountsPaymentCsvFailureReducer,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_PDF_FAILURE]: accountsPaymentPdfFailureReducer,
    [PaymentTrackTypes.PAYMENT_TRACKS_CSV_FAILURE]: paymentTracksCsvFailure,
    [PaymentTrackTypes.PAYMENT_TRACKS_PDF_FAILURE]: paymentTracksPdfFailure,
    [PaymentTrackTypes.ACCOUNTS_PAYMENT_TOTALS_FAILURE]: accountsPaymentTotalsFailureReducer,
    [PaymentTrackTypes.PLAN_PAYMENT_SUMMARY_FAILURE]: planPaymentSummaryFailure,
    [PaymentTrackTypes.PLAN_RECONCILIATION_SUMMARY_FAILURE]: planReconciliationSummaryFailure,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_FAILURE]: externalColleagueSummaryFailure,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_CSV_FAILURE]: externalColleagueSummaryCsvFailure,
    [PaymentTrackTypes.EXTERNAL_COLLEAGUE_SUMMARY_PDF_FAILURE]: externalColleagueSummaryPdfFailure,
    [PaymentTrackTypes.PAYMENT_TRACKS_SUMMARY_PDF_FAILURE]: paymentTracksSummaryPdfFailure,
    [PaymentTrackTypes.PAYMENT_TRACKS_RECONCILIATION_PDF_FAILURE]: paymentTracksReconciliationPdfFailure,
})
